var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"server-not-found"},[_c('div',{staticClass:"server-not-found__title"},[_vm._v(" 500 ")]),_c('div',{staticClass:"server-not-found__text"},[_vm._v(" "+_vm._s(_vm.$t('serverNotFound'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }